export const services = [
  {
    id: "diagnostic",
    title: "Diagnostic automobile",
    description:
      "Lecture et analyse des défauts, recherche de panne, identification de l'origine d'un dysfonctionnement et contrôle avant intervention.",
    icon: "ri-dashboard-3-line",
  },
  {
    id: "recherche-panne",
    title: "Recherche de panne",
    description:
      "Étape importante permettant d'identifier le problème avant d'établir un devis ou de réaliser une intervention.",
    icon: "ri-search-line",
  },
  {
    id: "entretien",
    title: "Entretien et révision",
    description:
      "Entretien courant, révision automobile et vérification des principaux éléments du véhicule, accessible à différentes marques.",
    icon: "ri-tools-line",
  },
  {
    id: "distribution",
    title: "Distribution",
    description:
      "Courroie de distribution, chaîne, galets, pompe à eau : contrôle et remplacement selon les besoins du véhicule.",
    icon: "ri-settings-3-line",
  },
  {
    id: "freinage",
    title: "Freinage",
    description:
      "Plaquettes, disques, liquide de frein et contrôle du système de freinage pour votre sécurité.",
    icon: "ri-disc-line",
  },
  {
    id: "embrayage",
    title: "Embrayage",
    description:
      "Diagnostic et remplacement complet de l'embrayage selon le besoin constaté sur votre véhicule.",
    icon: "ri-steering-line",
  },
  {
    id: "amortisseurs",
    title: "Amortisseurs",
    description:
      "Contrôle, remplacement et intervention liée à la tenue de route et à la sécurité du véhicule.",
    icon: "ri-car-line",
  },
  {
    id: "produits-entretien",
    title: "Produits d'entretien",
    description:
      "Vente de produits Liqui Moly : huiles moteur, additifs, nettoyants et produits d'entretien automobile disponibles directement au garage.",
    icon: "ri-oil-line",
  },
];

export const steps = [
  {
    number: "01",
    title: "Prise de contact",
    description:
      "Vous présentez votre besoin par téléphone, par e-mail ou en venant au garage. L'équipe vous écoute pour comprendre la situation de votre véhicule.",
    icon: "ri-phone-line",
  },
  {
    number: "02",
    title: "Diagnostic ou contrôle",
    description:
      "Le véhicule est analysé pour identifier l'origine du problème ou évaluer l'état des éléments à contrôler.",
    icon: "ri-search-line",
  },
  {
    number: "03",
    title: "Présentation du devis",
    description:
      "Un devis est établi et présenté avec les explications nécessaires. L'intervention est définie selon le problème constaté.",
    icon: "ri-file-list-3-line",
  },
  {
    number: "04",
    title: "Intervention après accord",
    description:
      "Les travaux sont réalisés après votre accord. Un devis peut être demandé à tout moment.",
    icon: "ri-tools-fill",
  },
];

export const galleryImages = [
  {
    id: 1,
    alt: "Véhicule en réparation sur pont élévateur au garage Mobicar Pro",
    label: "Atelier de réparation",
    src: "/assets/images/gallery-1.webp",
  },
  {
    id: 2,
    alt: "Présentoir de produits d'entretien Liqui Moly au garage",
    label: "Produits d'entretien",
    src: "/assets/images/gallery-2.webp",
  },
  {
    id: 3,
    alt: "Véhicule sur pont élévateur pour un contrôle technique au garage",
    label: "Contrôle et diagnostic",
    src: "/assets/images/gallery-3.webp",
  },
  {
    id: 4,
    alt: "Entrée du garage Mobicar Pro avec le panneau visible depuis la rue",
    label: "Accès au garage",
    src: "/assets/images/gallery-4.webp",
  },
  {
    id: 5,
    alt: "Accueil du garage Mobicar Pro avec espace d'attente clients",
    label: "Espace d'accueil",
    src: "/assets/images/gallery-5.webp",
  },
  {
    id: 6,
    alt: "Rayon d'huiles moteur et produits d'entretien Liqui Moly",
    label: "Huiles et lubrifiants",
    src: "/assets/images/gallery-6.webp",
  },
];

export const reviews = [
  {
    id: 1,
    author: "Bastien Guelt",
    authorInitials: "BG",
    text: "Service professionnel et efficace. Je recommande.",
  },
  {
    id: 2,
    author: "Marine Bigot",
    authorInitials: "MB",
    text: "Très professionnel, très à l'écoute, je recommande à 100 %, je suis très satisfaite du travail qui a été fait sur ma voiture.",
  },
  {
    id: 3,
    author: "Cyril Ahken",
    authorInitials: "CA",
    text: "Je tiens à remercier Mobicar. Travail propre, sérieux et efficace. A su identifier la panne, je recommande.",
  },
];

export const hours = [
  { day: "Lundi", morning: "8 h–12 h", afternoon: "14 h–17 h", isOpen: true },
  { day: "Mardi", morning: "8 h–12 h", afternoon: "14 h–17 h", isOpen: true },
  { day: "Mercredi", morning: "8 h–12 h", afternoon: "14 h–17 h", isOpen: true },
  { day: "Jeudi", morning: "8 h–12 h", afternoon: "14 h–17 h", isOpen: true },
  { day: "Vendredi", morning: "8 h–12 h", afternoon: "14 h–17 h", isOpen: true },
  { day: "Samedi", morning: "Fermé", afternoon: "Fermé", isOpen: false },
  { day: "Dimanche", morning: "Fermé", afternoon: "Fermé", isOpen: false },
];

export const aboutFeatures = [
  "Diagnostic et recherche de panne",
  "Devis sur demande",
  "Explications claires",
  "Intervention après accord",
];

export const contactInfo = {
  phone: "06 93 03 52 38",
  phoneHref: "tel:+262693035238",
  email: "contact@mobicar.pro",
  emailHref: "mailto:contact@mobicar.pro",
  whatsappDevisHref:
    "https://wa.me/262693035238?text=Bonjour%2C%20je%20souhaite%20obtenir%20un%20devis%20pour%20mon%20v%C3%A9hicule.",
  address: "14 rue Georges Pompidou, PK 12",
  city: "97430 Le Tampon, La Réunion",
  fullAddress: "14 rue Georges Pompidou, PK 12, 97430 Le Tampon, La Réunion",
  mapsQuery: "Mobicar+Pro,+14+rue+Georges+Pompidou,+Le+Tampon,+La+Réunion",
};

export const navLinks = [
  { label: "Accueil", href: "#accueil" },
  { label: "Prestations", href: "#prestations" },
  { label: "Le garage", href: "#garage" },
  { label: "Réalisations", href: "#realisations" },
  { label: "Avis", href: "#avis" },
  { label: "Horaires et accès", href: "#horaires" },
];